<template>
  <div>
    <LandingPage />
  </div>
</template>
<script setup>
import LandingPage from '../components/LandingPage.vue';
</script>